export default __webpack_public_path__ + "static/atrium_img3-4588aac496412d926cbeea59bbfd0743.png";